class Tabs {

    constructor() {
        this.element = '.personalizator__navs-item';
        this.tab = '.personalizator__product-image-content, .personalizator__product-details-controls-item';
        this.className = 'active';

        this.bindChange();
    }

    bindChange() {

        $(document).ready(() => {

            $(this.element).click((event) => {

                let item = $(event.target).attr('data-tab');

                $(this.element).removeClass(this.className);
                $(this.tab).removeClass('active');
                $(event.target).addClass(this.className);
                $(item).addClass(this.className);

            });

        });

    }

}

export const tabs = new Tabs();
